import { createFileRoute } from "@tanstack/react-router";
import FounderGraduation from "@/pages/FounderGraduation";

export const Route = createFileRoute("/accelerator/graduation/")({
  component: FounderGraduation,
});
